import React from 'react';

import ThemeContext from '../../context/ThemeContent/ThemeContext';

function withTheme(Component) {
    return props => (
        <ThemeContext.Consumer>
            {
                theme => <Component{...props} theme={theme} />
            }
        </ThemeContext.Consumer>
    );
}

export default withTheme;
